import { sendAnalyticsEvent } from '@/_analytic/send-analytics-event';
import { EAnalyticsEvents } from '@/_analytic/_types';

type TProps = {
  url: string;
};

export const telegramSourceEvent = (props: TProps) => {
  sendAnalyticsEvent({
    name: EAnalyticsEvents.TELEGRAM_UTM_SOURCE,
    params: props,
  });
};
